import React, { useState, useEffect } from "react";
import emailjs from "emailjs-com";
import ReCAPTCHA from "react-google-recaptcha";
import "bootstrap/dist/css/bootstrap.min.css";
import "aos/dist/aos.css";
import AOS from "aos";

const Careers = () => {
  const [capVal, setCapVal] = useState(null);
  const [showDescription, setShowDescription] = useState({});

  useEffect(() => {
    AOS.init({ duration: 800, once: true });
  }, []);

  const toggleDescription = (index) => {
    setShowDescription((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        "service_wbw24pu",
        "template_x2wjto7",
        e.target,
        "Kh5k0K1qs98wTpbZV"
      )
      .then(() => {
        alert("✅ Message sent successfully!");
        window.location.reload();
      })
      .catch((error) => console.error("Error sending email:", error));
  };

  const jobPositions = [
    {
      title: "CONSTRUCTION MATERIALS FIELD TECHNICIAN",
      type: "Full-Time",
      location: "Wesley Chapel, FL",
      description: (
        <div>
          <h6>Job Responsibilities:</h6>
          <ul>
            <li>
              Travel to construction sites using a company-provided vehicle.
            </li>
            <li>
              Conduct sampling and testing of soil, concrete, and asphalt.
            </li>
            <li>Interpret construction plans and follow project directions.</li>
          </ul>
          <h6>Working Conditions & Physical Requirements:</h6>
          <ul>
            <li>Work outdoors in varying weather conditions.</li>
            <li>Lift or move material samples up to 40 lbs.</li>
          </ul>
          <h6>Minimum Qualifications:</h6>
          <ul>
            <li>High school diploma or equivalent.</li>
            <li>Valid driver’s license and clean driving record.</li>
          </ul>
          <h6>Preferred Qualifications:</h6>
          <ul>
            <li>Experience in field testing or construction materials.</li>
            <li>ACI or CTQP certifications preferred.</li>
          </ul>
        </div>
      ),
    },
  ];

  return (
    <section className="careers-section py-5">
      <div className="container">
        <div className="title-area text-center mb-5" data-aos="fade-up">
          <div className="shadow-title">Careers</div>
          <span className="sub-title6 justify-content-center">
            <span className="shape left">
              <span className="dots" />
            </span>
            IMT Careers
            <span className="shape right">
              <span className="dots" />
            </span>
          </span>
          <h2 className="sec-title fw-semibold">Open Positions</h2>
        </div>

        <div className="mt-5 row g-4 justify-content-center">
          {jobPositions.map((job, index) => (
            <div
              key={index}
              className="col-lg-6 col-md-8"
              data-aos="fade-up"
              data-aos-delay={index * 100}
            >
              <div className="card job-card border-0 rounded-4 p-4 position-relative shadow-lg">
                <div className="ribbon">Now Hiring</div>
                <h4 className="fw-bold text-dark mb-1">{job.title}</h4>
                <p className="text-muted mb-2">
                  <i className="bi bi-geo-alt-fill text-success me-1"></i>
                  {job.location} | {job.type}
                </p>
                <button
                  onClick={() => toggleDescription(index)}
                  className="btn btn-outline-success mt-2"
                >
                  {showDescription[index]
                    ? "Hide Description"
                    : "View Description"}
                </button>

                <div
                  className={`collapse-content mt-3 ${
                    showDescription[index] ? "open" : ""
                  }`}
                >
                  <div className="p-3 bg-light rounded-3">
                    {job.description}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-5 mb-4" data-aos="fade-up">
          <h2
            className="fw-bold"
            style={{ color: "#198754", letterSpacing: "1px" }}
          >
            Join Our Team
          </h2>
          <p className="text-muted">
            We’re always looking for talented individuals to help us grow.
          </p>
        </div>
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <form
              onSubmit={sendEmail}
              data-aos="zoom-in"
              className="p-5 bg-white shadow-lg rounded-4"
              style={{
                borderTop: "5px solid #198754",
                transition: "box-shadow 0.3s ease",
              }}
            >
              <div className="row g-3">
                <div className="col-md-6">
                  <label className="form-label fw-semibold">Full Name*</label>
                  <input
                    type="text"
                    name="name"
                    className="form-control rounded-pill"
                    placeholder="Enter your name"
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label fw-semibold">Email*</label>
                  <input
                    type="email"
                    name="email"
                    className="form-control rounded-pill"
                    placeholder="Enter your email"
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label fw-semibold">Phone*</label>
                  <input
                    type="tel"
                    name="phone"
                    className="form-control rounded-pill"
                    placeholder="(123) 456-7890"
                    required
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label fw-semibold">Position*</label>
                  <select
                    name="position"
                    className="form-select rounded-pill"
                    required
                  >
                    <option value="">Select a position</option>
                    <option value="Any">Any</option>
                    <option value="Field Technician">Field Technician</option>
                    <option value="Assistant Lab Tech">
                      Assistant Lab Tech
                    </option>
                  </select>
                </div>
                <div className="col-12">
                  <label className="form-label fw-semibold">
                    Tell us about your employment history*
                  </label>
                  <textarea
                    name="message"
                    className="form-control rounded-4"
                    rows="4"
                    placeholder="Share your experience..."
                    required
                  ></textarea>
                </div>
                <div className="col-12 d-flex justify-content-center mt-2">
                  <ReCAPTCHA
                    sitekey="6LckIrcpAAAAAEKIsF1phIPq_I_s4xQDXwuK1qut"
                    onChange={(val) => setCapVal(val)}
                    onExpired={() => setCapVal(null)}
                  />
                </div>
                <div className="col-12 text-center">
                  {!capVal && (
                    <small className="text-danger d-block mb-2">
                      Please verify you’re not a robot before sending.
                    </small>
                  )}
                  <button
                    type="submit"
                    disabled={!capVal}
                    className="btn px-5 py-2 rounded-pill mt-3"
                    style={{
                      backgroundColor: "#198754",
                      color: "white",
                      fontWeight: "600",
                      letterSpacing: "1px",
                      transition: "all 0.3s ease",
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.backgroundColor = "white";
                      e.target.style.color = "#198754";
                      e.target.style.border = "2px solid #198754";
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.backgroundColor = "#198754";
                      e.target.style.color = "white";
                      e.target.style.border = "none";
                    }}
                  >
                    Submit Application
                  </button>
                  <div className="text-center mt-4">
                    <p className="text-muted mb-0">
                      📎 Please email any resumes to{" "}
                      <a
                        href="mailto:careers@imt.org"
                        style={{ color: "#198754", fontWeight: "600" }}
                      >
                        info@integrity-mt.com
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>

      <style>{`

        .job-card {
          background: white;
          transition: transform 0.4s ease, box-shadow 0.4s ease;
          border-top: 4px solid #198754;
        }
        .job-card:hover {
          transform: translateY(-10px);
          box-shadow: 0 20px 40px rgba(0,0,0,0.1);
        }
        .ribbon {
          position: absolute;
          top: 15px;
          right: -40px;
          background: #198754;
          color: white;
          transform: rotate(45deg);
          padding: 5px 40px;
          font-size: 0.8rem;
          font-weight: bold;
        }
        .collapse-content {
          max-height: 0;
          overflow: hidden;
          transition: all 0.5s ease;
        }
        .collapse-content.open {
          max-height: 1000px;
        }
        .application-form {
          background: linear-gradient(135deg, #198754, #146c43);
          color: white;
        }
        .apply-btn:hover {
          background-color: #198754;
          color: white;
          transform: scale(1.05);
        }
        .title-area .sec-title {
          color: #000000ff;
        }
        .title-area .dots {
          background-color: #198754;
        }
      `}</style>
    </section>
  );
};

export default Careers;
